import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { UsersService } from '../user-management/users/users.service';

@Injectable()
export class ProductsPermissionResolver implements Resolve<boolean> {
  constructor(private usersService: UsersService) {}

  public resolve(): Observable<boolean> {
    this.usersService.getUser();
    return this.usersService.allowProducts();
  }
}
